import { Auth, API } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import Mixpanel from 'mixpanel-browser';
// Utils
import checkError from 'utils/check-error';

// Redux
import {
    INIT,
    SET_COGNITO_USER,
    GET_COGNITO_USER_SUCCESS,
    GET_COGNITO_USER_ERROR,
    COGNITO_USER_SIGN_OUT_SUCCESS,
    COGNITO_USER_SIGN_OUT_ERROR,
} from 'redux/reducers/cognitoUser';

// Constants
import { policyIdentifiers } from 'global-constants';

export const get = () => async (dispatch, getState) => {
    const { cognitoUser } = getState();
    let response;

    // Catch errors we don't want to throw here
    try {
        await Auth.currentAuthenticatedUser(); // We don't care to alert the user of the catch case here which is "not authenticated" everytime we check
        response = await Auth.currentSession(); // We don't care to alert the user of the catch case here which is "no current user" everytime we check
    } catch (error) {
        console.log(checkError(error));

        await dispatch(signOut());
        dispatch({
            type: GET_COGNITO_USER_ERROR,
        });

        return;
    }

    try {
        const payload = response.idToken.payload;

        const user = await API.get('ClutchAPI', '/users/current');
        if (user.Organizations.length === 0) throw new Error('Account is not associated to an organization');
        if (!user.policies[policyIdentifiers.MEMBER_APP_LOGIN])
            throw new Error('Account does not have permission to login to the Clutch Member Dashboard');

        dispatch({
            type: GET_COGNITO_USER_SUCCESS,
            payload: {
                ...payload,
                ...user,
                Organization: cognitoUser?.Organization
                    ? cognitoUser.Organization
                    : user.Organizations.length > 1
                    ? null
                    : user.Organizations[0],
            },
        });

        Mixpanel.identify(user.sub);
        Mixpanel.register({
            email: user.email.value,
            firstName: user.firstName,
            lastName: user.lastName,
        });
        Mixpanel.people.set({
            $email: user.email.value,
            firstName: user.firstName,
            lastName: user.lastName,
            USER_ID: user.sub,
        });
        Mixpanel.track('User Login');

        return { ...payload, ...user };
    } catch (error) {
        console.log(checkError(error));

        await dispatch(signOut());
        dispatch({
            type: GET_COGNITO_USER_ERROR,
        });

        throw error;
    }
};

export const signOut = () => async (dispatch) => {
    try {
        await dispatch({
            type: COGNITO_USER_SIGN_OUT_SUCCESS,
            payload: cloneDeep(INIT),
        });
        await Auth.signOut();
        await Auth.cleanCachedItems();

        /** Remove all local storage cognito items. */
        Object.keys(localStorage).forEach((key) => {
            if (key.toLowerCase().includes('cognito')) {
                localStorage.removeItem(key);
            }
        });

        return true;
    } catch (error) {
        console.log(error);
        dispatch({
            type: COGNITO_USER_SIGN_OUT_ERROR,
        });

        return false;
    }
};

export const set = (user) => {
    if (user) {
        return {
            type: SET_COGNITO_USER,
            payload: user,
        };
    }

    // Empty user in store if no user is sent
    return {
        type: SET_COGNITO_USER,
        payload: cloneDeep(INIT),
    };
};
